import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaUserCog, FaUserMd, FaCalendarAlt, FaChartBar, FaPlus, FaTrash, FaEdit, FaSearch } from 'react-icons/fa';
import Layout from './layout';
import { useAuth } from './context/AuthContext';
import axios from 'axios';
import { appointmentService } from './AppointmentsService';
import Navbar from './AdminNav';
import { FaUserShield } from 'react-icons/fa'; // For admin icon


const AdminDashboard = () => {
    const { currentUser } = useAuth();
    const [users, setUsers] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [stats, setStats] = useState({
        totalUsers: 0,
        totalDoctors: 0,
        totalAppointments: 0,
        appointmentsToday: 0,
        appointmentsCompleted: 0
    });
    const [activeTab, setActiveTab] = useState('users');
    const [showNewDoctorModal, setShowNewDoctorModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');
    const [newDoctor, setNewDoctor] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        specialty: '',
        phone: ''
    });
    const [showEditDoctorModal, setShowEditDoctorModal] = useState(false);
const [doctorToEdit, setDoctorToEdit] = useState(null);
const [admins, setAdmins] = useState([]);


// Function to open the edit modal with selected doctor's data
const openEditDoctorModal = (doctor) => {
    setDoctorToEdit({
        id: doctor._id,
        firstName: doctor.firstName,
        lastName: doctor.lastName,
        email: doctor.email,
        specialty: doctor.specialization || doctor.specialty || '',
        phone: doctor.phone || '',
        password: '' // Leave empty, only update if provided
    });
    setShowEditDoctorModal(true);
};

// Function to handle the doctor update
const handleUpdateDoctor = async () => {
    try {
        // Create update payload, omitting password if it's empty
        const updatePayload = {
            firstName: doctorToEdit.firstName,
            lastName: doctorToEdit.lastName,
            email: doctorToEdit.email,
            specialty: doctorToEdit.specialty,
            phone: doctorToEdit.phone
        };
        
        // Only include password if it was changed
        if (doctorToEdit.password) {
            updatePayload.password = doctorToEdit.password;
        }
        
        const response = await axios.put(
            `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/doctors/${doctorToEdit.id}`, 
            updatePayload
        );
        
        // Update the doctors state with the updated doctor
        const updatedDoctors = doctors.map(doc => 
            doc._id === doctorToEdit.id ? {...doc, ...updatePayload} : doc
        );
        
        setDoctors(updatedDoctors);
        setShowEditDoctorModal(false);
        setDoctorToEdit(null);
        
        // Show success message
        alert("Doctor updated successfully");
    } catch (error) {
        console.error("Error updating doctor:", error);
        alert("Failed to update doctor: " + (error.response?.data?.message || error.message));
    }
};
// Add this function near your other utility functions

// Helper function to create avatar initials from name
const getInitials = (firstName, lastName) => {
    return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
  };
  
  // Add this default avatar component at the top of the file with your imports
  const Avatar = ({ user, size = "md" }) => {
    const initials = getInitials(user.firstName, user.lastName);
    const colors = {
      'admin': 'bg-purple-500',
      'doctor': 'bg-green-500',
      'patient': 'bg-blue-500'
    };
    
    const sizes = {
      'sm': 'w-8 h-8 text-xs',
      'md': 'w-10 h-10 text-sm',
      'lg': 'w-12 h-12 text-base'
    };
    
    return (
      <div className={`${sizes[size]} ${colors[user.role] || 'bg-gray-500'} rounded-full flex items-center justify-center text-white font-medium`}>
        {initials}
      </div>
    );
  };

    // Fetch data on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch users
                const usersResponse = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/users`);
                setUsers(usersResponse.data.users);
                console.log('Users:', usersResponse.data);
                
                // Fetch doctors
                const doctorsResponse = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/users`);
                setDoctors(doctorsResponse.data.doctors);

                const adminsResponse = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/admins`);
                setAdmins(adminsResponse.data.admins)

            console.log('Admins:', adminsResponse);
                
                // Fetch appointments
                const appointmentsData = await appointmentService.getAllAppointments();
                setAppointments(appointmentsData);
                
                // Calculate stats
                setStats({
                    totalUsers: usersResponse.data.users.length,
                    totalDoctors: doctorsResponse.data.doctors.length || '0',
                    totalAppointments: appointmentsData.length,
                    appointmentsToday: appointmentsData.filter(appt => 
                        new Date(appt.startTime).toDateString() === new Date().toDateString()
                    ).length,
                    appointmentsCompleted: appointmentsData.filter(appt => 
                        new Date(appt.endTime) < new Date()
                    ).length
                });
                
                setLoading(false);
            } catch (error) {
                console.error("Error fetching admin data:", error);
                setLoading(false);
            }
        };

        if (currentUser?.role === 'admin') {
            fetchData();
        }
    }, [currentUser]);

    const handleCreateDoctor = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/doctors`, 
                newDoctor
            );
            setDoctors([...doctors, response.data]);
            setShowNewDoctorModal(false);
            setNewDoctor({
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                specialty: '',
                phone: ''
            });
        } catch (error) {
            console.error("Error creating doctor:", error);
        }
    };

    const handleDeleteUser = async (userId) => {
        if (window.confirm("Are you sure you want to delete this user?")) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/users/${userId}`);
                setUsers(users.filter(user => user._id !== userId));
            } catch (error) {
                console.error("Error deleting user:", error);
            }
        }
    };

    const handleDeleteAppointment = async (appointmentId) => {
        if (window.confirm("Are you sure you want to delete this appointment?")) {
            try {
                await appointmentService.deleteAppointment(appointmentId);
                setAppointments(appointments.filter(appointment => appointment._id !== appointmentId));
            } catch (error) {
                console.error("Error deleting appointment:", error);
            }
        }
    };

    const filterItems = (items) => {
        if (!searchQuery) return items;
        
        return items.filter(item => 
            item.firstName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.lastName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            item.title?.toLowerCase().includes(searchQuery.toLowerCase())
        );
    };

    // const fetchData = async () => {
    //     try {
    //         // Your existing fetch code...
            
    //         // Fetch admins
    //         const adminsResponse = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/admins`);
    //         console.log('Admins:', adminsResponse.data);
    //         // setAdmins(adminsResponse.data || []);
            
    //         // Rest of your existing fetch code...
    //     } catch (error) {
    //         console.error("Error fetching admin data:", error);
    //         setLoading(false);
    //     }
    // };
    
    // Add this new admin creation state and function
    const [showNewAdminModal, setShowNewAdminModal] = useState(false);
    const [newAdmin, setNewAdmin] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phone: ''
    });
    
    const handleCreateAdmin = async () => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/admins`, 
                newAdmin
            );
            setAdmins([...admins, response.data]);
            setShowNewAdminModal(false);
            setNewAdmin({
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                phone: ''
            });
            alert("Admin created successfully");
        } catch (error) {
            console.error("Error creating admin:", error);
            alert("Error creating admin: " + (error.response?.data?.message || error.message));
        }
    };
    
    // Add function to delete admin
    const handleDeleteAdmin = async (adminId) => {
        if (window.confirm("Are you sure you want to delete this administrator?")) {
            try {
                await axios.delete(`${process.env.REACT_APP_API_URL || 'http://localhost:5001/api'}/admin/admins/${adminId}`);
                setAdmins(admins.filter(admin => admin._id !== adminId));
                alert("Admin deleted successfully");
            } catch (error) {
                console.error("Error deleting admin:", error);
                alert("Error deleting admin: " + (error.response?.data?.message || error.message));
            }
        }
    };

    // Redirect if not admin
    if (currentUser?.role !== 'admin') {
        return (
            <Layout>
                <div className="container mx-auto px-4 py-10">
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
                        <p>Access denied. You must be an administrator to view this page.</p>
                    </div>
                </div>
            </Layout>
        );
    }

    return (
        <>
        <Navbar />
            <div className="container mx-auto px-4 py-20">
                <h1 className="text-3xl font-bold mb-8">Admin Dashboard</h1>
                
                {/* Stats Cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">
                    <div className="bg-blue-50 p-4 rounded-lg shadow-md border border-blue-100">
                        <p className="text-blue-800 text-sm font-medium">Total Users</p>
                        <p className="text-3xl font-bold">{stats.totalUsers}</p>
                    </div>
                    <div className="bg-green-50 p-4 rounded-lg shadow-md border border-green-100">
                        <p className="text-green-800 text-sm font-medium">Total Doctors</p>
                        <p className="text-3xl font-bold">{stats.totalDoctors}</p>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-lg shadow-md border border-purple-100">
                        <p className="text-purple-800 text-sm font-medium">Total Appointments</p>
                        <p className="text-3xl font-bold">{stats.totalAppointments}</p>
                    </div>
                    <div className="bg-amber-50 p-4 rounded-lg shadow-md border border-amber-100">
                        <p className="text-amber-800 text-sm font-medium">Today's Appointments</p>
                        <p className="text-3xl font-bold">{stats.appointmentsToday}</p>
                    </div>
                    <div className="bg-teal-50 p-4 rounded-lg shadow-md border border-teal-100">
                        <p className="text-teal-800 text-sm font-medium">Completed Appointments</p>
                        <p className="text-3xl font-bold">{stats.appointmentsCompleted}</p>
                    </div>
                </div>
                
                {/* Tabs */}
                <div className="flex mb-6 border-b">
                    <button 
                        className={`px-6 py-3 flex items-center ${activeTab === 'users' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`}
                        onClick={() => setActiveTab('users')}
                    >
                        <FaUserCog className="mr-2" /> Manage Users
                    </button>
                    <button 
                        className={`px-6 py-3 flex items-center ${activeTab === 'doctors' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`}
                        onClick={() => setActiveTab('doctors')}
                    >
                        <FaUserMd className="mr-2" /> Doctor Management
                    </button>
                    <button 
                        className={`px-6 py-3 flex items-center ${activeTab === 'appointments' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`}
                        onClick={() => setActiveTab('appointments')}
                    >
                        <FaCalendarAlt className="mr-2" /> Appointments
                    </button>
                    <button 
                        className={`px-6 py-3 flex items-center ${activeTab === 'stats' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`}
                        onClick={() => setActiveTab('stats')}
                    >
                        <FaChartBar className="mr-2" /> Statistics
                    </button>
                    <button 
    className={`px-6 py-3 flex items-center ${activeTab === 'admins' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-600'}`}
    onClick={() => setActiveTab('admins')}
>
    <FaUserShield className="mr-2" /> Manage Admins
</button>
                </div>
                
                {/* Search Bar */}
                <div className="relative mb-6">
                    <input
                        type="text"
                        placeholder={`Search ${activeTab}...`}
                        className="w-full px-4 py-2 pl-10 border rounded-lg focus:ring-2 focus:ring-blue-300 focus:border-blue-300"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <FaSearch className="absolute left-3 top-3 text-gray-400" />
                </div>
                
                {/* Content based on active tab */}
                {loading ? (
                    <div className="flex justify-center items-center h-64">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                    </div>
                ) : (
                    <>
                        {/* Users Tab */}
                        {activeTab === 'users' && (
                            <div className="bg-white shadow-md rounded-lg overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {filterItems(users).map((user) => (
                                            <tr key={user._id}>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="flex items-center">
                                                        <div className="ml-4">
                                                            <div className="text-sm font-medium text-gray-900">{user.firstName} {user.lastName}</div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm text-gray-900">{user.email}</div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                                                        ${user.role === 'admin' ? 'bg-purple-100 text-purple-800' : 
                                                          user.role === 'doctor' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                                                        {user.role}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                    <button className="text-indigo-600 hover:text-indigo-900 mr-3">
                                                        <FaEdit />
                                                    </button>
                                                    <button 
                                                        className="text-red-600 hover:text-red-900"
                                                        onClick={() => handleDeleteUser(user._id)}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        
                        {/* Doctors Tab */}
                        {activeTab === 'doctors' && (
                            <div>
                                <div className="flex justify-end mb-4">
                                    <button 
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center"
                                        onClick={() => setShowNewDoctorModal(true)}
                                    >
                                        <FaPlus className="mr-2" /> Add New Doctor
                                    </button>
                                </div>
                                <div className="bg-white shadow-md rounded-lg overflow-hidden">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Specialization</th>
                                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {filterItems(doctors).map((doctor) => (
                                                <tr key={doctor._id}>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center">
                                                            <div className="ml-4">
                                                                <div className="text-sm font-medium text-gray-900">Dr. {doctor.firstName} {doctor.lastName}</div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="text-sm text-gray-900">{doctor.email}</div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="text-sm text-gray-900">{doctor.specialization || 'General'}</div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                    <button 
    className="text-indigo-600 hover:text-indigo-900 mr-3"
    onClick={() => openEditDoctorModal(doctor)}
>
    <FaEdit />
</button>
                                                        <button 
                                                            className="text-red-600 hover:text-red-900"
                                                            onClick={() => handleDeleteUser(doctor._id)}
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                        
                        {/* Appointments Tab */}
                        {activeTab === 'appointments' && (
                            <div className="bg-white shadow-md rounded-lg overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Title</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date & Time</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {filterItems(appointments).map((appointment) => (
                                            <tr key={appointment._id}>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm font-medium text-gray-900">{appointment.title}</div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <div className="text-sm text-gray-900">
                                                        {new Date(appointment.startTime).toLocaleDateString()}, {" "}
                                                        {new Date(appointment.startTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                                                        ${new Date(appointment.endTime) < new Date() ? 'bg-gray-100 text-gray-800' : 
                                                         new Date(appointment.startTime) > new Date() ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                                        {new Date(appointment.endTime) < new Date() ? 'Completed' : 
                                                         new Date(appointment.startTime) > new Date() ? 'Upcoming' : 'In Progress'}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                    <button className="text-indigo-600 hover:text-indigo-900 mr-3">
                                                        <FaEdit />
                                                    </button>
                                                    <button 
                                                        className="text-red-600 hover:text-red-900"
                                                        onClick={() => handleDeleteAppointment(appointment._id)}
                                                    >
                                                        <FaTrash />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                        
                        {/* Statistics Tab */}
                        {activeTab === 'stats' && (
                            <div className="bg-white p-6 rounded-lg shadow-md">
                                <h3 className="text-lg font-semibold mb-4">System Statistics</h3>
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                                    <div className="bg-blue-50 p-4 rounded-lg">
                                        <h4 className="font-medium mb-2">User Distribution</h4>
                                        <p>Patients: {users.filter(u => u.role === 'patient').length}</p>
                                        <p>Doctors: {doctors.length}</p>
                                        <p>Admins: {admins.length}</p>
                                    </div>
                                    
                                    <div className="bg-green-50 p-4 rounded-lg">
                                        <h4 className="font-medium mb-2">Appointment Analytics</h4>
                                        <p>Today: {stats.appointmentsToday}</p>
                                        <p>This Week: {appointments.filter(a => 
                                            new Date(a.startTime) >= new Date(new Date().setDate(new Date().getDate() - 7)) && 
                                            new Date(a.startTime) <= new Date()).length}
                                        </p>
                                        <p>This Month: {appointments.filter(a => 
                                            new Date(a.startTime).getMonth() === new Date().getMonth() && 
                                            new Date(a.startTime).getFullYear() === new Date().getFullYear()).length}
                                        </p>
                                    </div>
                                    
                                    <div className="bg-purple-50 p-4 rounded-lg">
                                        <h4 className="font-medium mb-2">System Health</h4>
                                        <p>Server Status: <span className="text-green-600">●</span> Online</p>
                                        <p>Database Status: <span className="text-green-600">●</span> Connected</p>
                                        <p>Last Backup: {new Date().toLocaleDateString()}</p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Admins Tab */}
{activeTab === 'admins' && (
    <div>
        <div className="flex justify-end mb-4">
            <button 
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center"
                onClick={() => setShowNewAdminModal(true)}
            >
                <FaPlus className="mr-2" /> Add New Admin
            </button>
        </div>
        <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {filterItems(admins).map((admin) => (
                        <tr key={admin._id}>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                    <Avatar user={{...admin, role: 'admin'}} size="sm" />
                                    <div className="ml-4">
                                        <div className="text-sm font-medium text-gray-900">
                                            {admin.firstName} {admin.lastName}
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">{admin.email}</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="text-sm text-gray-900">{admin.phone || 'N/A'}</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                {currentUser._id !== admin._id && (
                                    <button 
                                        className="text-red-600 hover:text-red-900"
                                        onClick={() => handleDeleteAdmin(admin._id)}
                                    >
                                        <FaTrash />
                                    </button>
                                )}
                                {currentUser._id === admin._id && (
                                    <span className="text-xs text-gray-500 italic">Current User</span>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </div>
)}
                    </>
                )}
            </div>
            
            {/* New Doctor Modal */}
            {showNewDoctorModal && (
                <div className="fixed inset-0 z-10 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
                    <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setShowNewDoctorModal(false)}></div>
                        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                        
                        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Add New Doctor</h3>
                                
                                <div className="grid grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                                        <input 
                                            type="text" 
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                            value={newDoctor.firstName}
                                            onChange={(e) => setNewDoctor({...newDoctor, firstName: e.target.value})}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                                        <input 
                                            type="text" 
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                            value={newDoctor.lastName}
                                            onChange={(e) => setNewDoctor({...newDoctor, lastName: e.target.value})}
                                        />
                                    </div>
                                    <div className="col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                                        <input 
                                            type="email" 
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                            value={newDoctor.email}
                                            onChange={(e) => setNewDoctor({...newDoctor, email: e.target.value})}
                                        />
                                    </div>
                                    <div className="col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                                        <input 
                                            type="password" 
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                            value={newDoctor.password}
                                            onChange={(e) => setNewDoctor({...newDoctor, password: e.target.value})}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Specialization</label>
                                        <input 
                                            type="text" 
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                            value={newDoctor.specialty}
                                            onChange={(e) => setNewDoctor({...newDoctor,  specialty: e.target.value})}
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                                        <input 
                                            type="text" 
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                            value={newDoctor.phone}
                                            onChange={(e) => setNewDoctor({...newDoctor, phone: e.target.value})}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                                <button 
                                    type="button" 
                                    className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={handleCreateDoctor}
                                >
                                    Create Doctor
                                </button>
                                <button 
                                    type="button" 
                                    className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                                    onClick={() => setShowNewDoctorModal(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Edit Doctor Modal */}
{showEditDoctorModal && doctorToEdit && (
    <div className="fixed inset-0 z-10 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setShowEditDoctorModal(false)}></div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
            
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Edit Doctor</h3>
                    
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                            <input 
                                type="text" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={doctorToEdit.firstName}
                                onChange={(e) => setDoctorToEdit({...doctorToEdit, firstName: e.target.value})}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                            <input 
                                type="text" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={doctorToEdit.lastName}
                                onChange={(e) => setDoctorToEdit({...doctorToEdit, lastName: e.target.value})}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input 
                                type="email" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={doctorToEdit.email}
                                onChange={(e) => setDoctorToEdit({...doctorToEdit, email: e.target.value})}
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                Password <span className="text-xs text-gray-500">(leave empty to keep current password)</span>
                            </label>
                            <input 
                                type="password" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={doctorToEdit.password}
                                onChange={(e) => setDoctorToEdit({...doctorToEdit, password: e.target.value})}
                                placeholder="••••••••"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Specialization</label>
                            <input 
                                type="text" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={doctorToEdit.specialty}
                                onChange={(e) => setDoctorToEdit({...doctorToEdit, specialty: e.target.value})}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                            <input 
                                type="text" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={doctorToEdit.phone}
                                onChange={(e) => setDoctorToEdit({...doctorToEdit, phone: e.target.value})}
                            />
                        </div>
                    </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button 
                        type="button" 
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={handleUpdateDoctor}
                    >
                        Update Doctor
                    </button>
                    <button 
                        type="button" 
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => setShowEditDoctorModal(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
)}




{/* New Admin Modal */}
{showNewAdminModal && (
    <div className="fixed inset-0 z-10 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setShowNewAdminModal(false)}></div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
            
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Add New Administrator</h3>
                    
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
                            <input 
                                type="text" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={newAdmin.firstName}
                                onChange={(e) => setNewAdmin({...newAdmin, firstName: e.target.value})}
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
                            <input 
                                type="text" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={newAdmin.lastName}
                                onChange={(e) => setNewAdmin({...newAdmin, lastName: e.target.value})}
                                required
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input 
                                type="email" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={newAdmin.email}
                                onChange={(e) => setNewAdmin({...newAdmin, email: e.target.value})}
                                required
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
                            <input 
                                type="password" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={newAdmin.password}
                                onChange={(e) => setNewAdmin({...newAdmin, password: e.target.value})}
                                required
                            />
                        </div>
                        <div className="col-span-2">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                            <input 
                                type="text" 
                                className="w-full px-3 py-2 border border-gray-300 rounded-md" 
                                value={newAdmin.phone}
                                onChange={(e) => setNewAdmin({...newAdmin, phone: e.target.value})}
                            />
                        </div>
                    </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                    <button 
                        type="button" 
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={handleCreateAdmin}
                    >
                        Create Administrator
                    </button>
                    <button 
                        type="button" 
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => setShowNewAdminModal(false)}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
)}
        </>
    );
};

export default AdminDashboard;